import { render, staticRenderFns } from "./DownloadClaimFile.vue?vue&type=template&id=51599af0&scoped=true&"
import script from "./DownloadClaimFile.vue?vue&type=script&lang=js&"
export * from "./DownloadClaimFile.vue?vue&type=script&lang=js&"
import style0 from "./DownloadClaimFile.vue?vue&type=style&index=0&id=51599af0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51599af0",
  null
  
)

export default component.exports